import styled from 'styled-components'

const StyledCartPrice = styled.div`
  display: flex;
  align-items: center;
  
  .pricing-discount {
    text-decoration: line-through;
  }
`

export default StyledCartPrice
